<ng-container *ngFor="let line of lines$ | async">
    <div class="row text-l" [class.ttu]="isSidebar">
        <div class="col {{ line.nameClass || '' }}">{{ line.name }}</div>
        <div *ngIf="(isRepayment$ | async) === false" class="col text-right text-nowrap {{ line.valueClass || '' }}">{{ line.value }}</div>
        <div *ngIf="(isRepayment$ | async) === true" class="col text-right text-nowrap {{ line.valueClass || '' }}">
            {{ repayTotalPrice$ | async }}
        </div>
    </div>
</ng-container>

<div class="row text-l mt-8" [class.ttu]="isSidebar" *ngIf="showWWDisclaimer$ | async">
    <!-- tax disclaimer -->
    <div class="col-xs-12">{{ 'dev.checkout.summary.unknownCost' | translate }}</div>
</div>

<div class="row mt-8 text-l" [class.ttu]="isSidebar" *ngIf="totalOrder$ | async as totalOrder">
    <div class="col-xs-6">{{ 'dev.general.total' | translate }}</div>
    <formatted-price
        class="col-xs-6"
        [price]="totalOrder"
        [options]="{ showAlternateCurrencies: true }"
        [pricesClasses]="{
            container: 'text-right text-nowrap',
            primaryPrice: '',
            alternativeCurrencies: 'title-s ttu'
        }"
    ></formatted-price>
</div>

<div class="row mt-8 text-l" *ngIf="totalPoints$ | async as totalPoints">
    <div class="col">
        <p>
            {{ 'dev.myaccount.mypurchase.pointsEarned' | translate: { $0: (totalPoints | formattedNumber: (languageCode$ | async)) } }}
        </p>
    </div>
    <div class="col text-right" (click)="viewFeelHistoric()">
        <a class="link-line text-l" [routerLink]="[baseUrl$ | async, 'my-account', 'feel', 'history']">{{
            'dev.myaccount.mypurchase.showHistoric' | translate
        }}</a>
    </div>
</div>

<div class="row mt-8 text-l" [class.ttu]="isSidebar" *ngIf="currencyInfoAlternates$ | async as currencyInfoAlternates">
    <div class="col-xs-12" *ngIf="currencyInfoAlternates.length > 0">
        <span class="text-m c-info">
            1{{ currencyCode$ | async }} = {{ currencyInfoAlternates[0].conversionRateString }} {{ currencyInfoAlternates[0].currencySymbol }}
        </span>
    </div>
</div>
